import { render } from "./Kyc.m.vue?vue&type=template&id=30c9e404"
import script from "./Kyc.m.vue?vue&type=script&lang=js"
export * from "./Kyc.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__